import React, { useRef } from "react";
import GuideDownload from "./GuideDownload";
//import DownloadsBadge from "./DownloadsBadge";

export default function NewsHomeCarousel({ items }) {
  const scroller = useRef(null);
  const scroll = (dx) =>
    scroller.current?.scrollBy({ left: dx, behavior: "smooth" });

  const slides = (items || [])
    .filter((a) => (a.category || "").toLowerCase().trim() === "guides")
    .slice(0, 6);

  // normalise common key variants coming from Sheets/APIs
  const getBase = (a = {}) =>
    a.base_downloads ??
    a.baseDownloads ??
    a.Base_downloads ??
    a.downloads_base ??
    a.base ??
    0;

  const getStart = (a = {}) => a.downloads_start || a.date || undefined;

  return (
    <div className="mt-8">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-[#003366]">Featured</h3>
        <div className="flex gap-2">
          <button
            onClick={() => scroll(-320)}
            className="rounded-full border border-slate-300 px-3 py-1 text-sm"
          >
            ◀
          </button>
          <button
            onClick={() => scroll(320)}
            className="rounded-full border border-slate-300 px-3 py-1 text-sm"
          >
            ▶
          </button>
        </div>
      </div>

      <div
        ref={scroller}
        className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2"
      >
        {slides.map((a) => {
          // ✅ debug in JS, not JSX
          console.log(
            "badge row",
            a.slug,
            a.base_downloads,
            a.baseDownloads,
            a.Base_downloads,
            a.downloads_base
          );

          return (
            <article
              key={a.id || a.slug}
              className="min-w-[280px] max-w-[280px] snap-start rounded-2xl bg-white shadow-sm ring-1 ring-slate-200 overflow-hidden"
            >
             <div className="relative">
                {/* Live count badge (overlay) */}
               {/* } <DownloadsBadge
                  item={{
                    slug: String(a.slug || a.id || a.guid || ""),
                    base_downloads: getBase(a),
                    downloads_start: getStart(a),
                  }}
                />*/}
                <img src={a.image} alt="" className="h-36 w-full object-cover" />
              </div> 

              <div className="p-4">
                <div className="text-xs font-semibold uppercase tracking-wide text-[#003366]">
                  {a.category}
                </div>
                <h4 className="mt-1 text-sm font-semibold text-[#003366]">
                  {a.title}
                </h4>

                <div className="mt-3 flex items-center gap-2 flex-wrap text-sm">
                  <a
                    href={
                      (a.category || "").toLowerCase() === "guides"
                        ? `#/guide/${a.slug}`
                        : `#/article/${a.slug}`
                    }
                    className="inline-flex items-center font-semibold text-[#003366]"
                  >
                    Read more →
                  </a>

                  {(a.category || "").toLowerCase() === "guides" && (
                    <GuideDownload
                      guideId={a.id || a.slug || a.guid}
                      guideTitle={a.title || a.name || a.heading || a.slug}
                      label="Download PDF"
                      buttonClassName="inline-flex items-center rounded-full bg-[#003366] text-white px-3 py-1 text-sm font-medium hover:bg-slate-800"
                    />
                  )}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
